import storageUtil from '@zet/utils/storage'

const useReturnUrl = () => {
  const url = storageUtil.getObject('returnUrl')

  return { url }
}

export { useReturnUrl }
